exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert[data-v-418363bc]{position:fixed;left:50%;top:20px;z-index:9999;width:80vw;transform:translate(-50%)}.fade-enter-active[data-v-418363bc],.fade-leave-active[data-v-418363bc]{transition:opacity .3s}.fade-enter[data-v-418363bc],.fade-leave-to[data-v-418363bc]{opacity:0}#edit_birth_year[data-v-418363bc]{min-width:70px}#edit_birth_day[data-v-418363bc],#edit_birth_month[data-v-418363bc]{min-width:45px}.icon-pencil[data-v-418363bc]{position:relative;top:2px;width:14px;margin-left:3px;cursor:pointer}", ""]);

// exports
